'use client';

import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
import { last } from 'lodash';
import { useMediaQuery } from 'usehooks-ts';
import { cn } from '@/utils/mergeClassName';
import { breadcrumbVariants } from './styles';

type BreadcrumbProps = React.ComponentProps<'nav'> & {
  maxItems?: number;
  withBackButton?: boolean;
};

const Breadcrumb = ({
  children,
  className,
  maxItems,
  withBackButton,
  ...rest
}: BreadcrumbProps) => {
  const isMobile = useMediaQuery('(max-width: 1023px)');
  const router = useRouter();
  const [showAll, setShowAll] = useState(false);
  const { nav, ol, li, button } = breadcrumbVariants();
  let items = children;

  if (isMobile) {
    maxItems = 1;
  }

  if (maxItems) {
    const childrenArray = React.Children.toArray(children);

    const Button = (
      <li className={li()} key="more-items">
        <button type="button" onClick={() => setShowAll(true)}>
          ...
        </button>
      </li>
    );

    if (maxItems === 1) {
      items = [Button, last(childrenArray)];
    } else if (maxItems >= childrenArray.length) {
      items = childrenArray;
    } else {
      items = [Button, ...childrenArray.slice(-maxItems)];
    }
  }

  return (
    <div role="presentation">
      <nav className={cn(nav(), className)} aria-label="breadcrumb" {...rest}>
        <ol className={ol()}>{showAll ? children : items}</ol>

        {withBackButton && (
          <button
            type="button"
            className={button({ className: 'hidden text-blue-400 hover:text-blue-500 lg:block' })}
            onClick={router.back}
          >
            Voltar
          </button>
        )}
      </nav>
    </div>
  );
};

const Root = Breadcrumb;

export { type BreadcrumbProps, Breadcrumb, Root };
